import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const DialCodeSelect = ({ value, onChange, countries, variant = 'light', testId = 'dialcode-select' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isDark = variant === 'dark';

  return (
    <div ref={ref} className="relative" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`flex items-center justify-between gap-1 w-20 sm:w-24 px-2 py-2 text-sm rounded-lg border transition-all ${
          isDark
            ? 'bg-white/10 border-white/20 text-white hover:bg-white/20 h-12'
            : 'bg-white border-gray-300 text-gray-900 hover:border-gray-400'
        } focus:outline-none focus:ring-2 focus:ring-[#FF035B]`}
      >
        <span>+{value}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''} ${isDark ? 'text-white/70' : 'text-gray-500'}`} />
      </button>

      {open && (
        <div className={`absolute z-50 mt-1 w-28 max-h-48 overflow-y-auto rounded-lg shadow-xl border ${
          isDark ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'
        }`}
          style={{ left: 0 }}
        >
          {countries.map((c, i) => (
            <button
              key={`${c.code}-${i}`}
              type="button"
              onClick={() => { onChange(c.dialCode); setOpen(false); }}
              className={`w-full text-left px-3 py-2 text-sm transition-colors ${
                c.dialCode === value
                  ? isDark ? 'bg-[#FF035B] text-white' : 'bg-[#FF035B]/10 text-[#FF035B] font-semibold'
                  : isDark ? 'text-white hover:bg-gray-800' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              +{c.dialCode}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DialCodeSelect;
